var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_2_1_",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.3,29.3H2.7C1.1,29.3,0,30.4,0,32c0,1.6,1.1,2.7,2.7,2.7h58.7c1.6,0,2.7-1.1,2.7-2.7C64,30.4,62.9,29.3,61.3,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,48H2.7C1.1,48,0,49.1,0,50.7c0,1.6,1.1,2.7,2.7,2.7h58.7c1.6,0,2.7-1.1,2.7-2.7C64,49.1,62.9,48,61.3,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,16h58.7c1.6,0,2.7-1.1,2.7-2.7s-1.1-2.7-2.7-2.7H2.7c-1.6,0-2.7,1.1-2.7,2.7S1.1,16,2.7,16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.3d2c9d70de093fb4c48c1977627fbc7b.svg";
export { ForwardRef as ReactComponent };